import styled, { x } from "@xstyled/styled-components"

const InfoBox = styled(x.div)`
  border-left: solid 2px;
  border-color: primary;
  padding: 2 3;
`

export default InfoBox
